import angular from 'angular';
import {configManager} from '../../util/config-manager/config-manager.js';
import {cookieUtil} from '../../util/cookie-util.js';
import {userProfileManager} from '../../util/user-profile-manager.js';
import CommonApp from '../app.js';

var intercepterConfig = function($provide, $httpProvider) {
    var aConfig = configManager.getAppConfig();
    var mulesoftClientId = aConfig.clientId;
    var mulesoftClientSecret = aConfig.clientSecret;

    /**
     *
     * @param {Array} arr
     * @param {String} what
     */
    function remove(arr, what) {
        var found = arr.indexOf(what);

        while (found !== -1) {
            arr.splice(found, 1);
            found = arr.indexOf(what);
        }
    }

    //* ********************
    // This is extracted from: /etc/clientlibs/mecommerce/core/main/js/app.js
    //* ********************
    // Intercept http calls.
    $provide.factory('CustomHttpInterceptor2', ['$q', '$rootScope', '$timeout', function($q, $rootScope, $timeout) {
        var numLoadings = 0;
        var urls = [];

        return {
            // On request success
            request: function(config) {
                // Contains the data about the request before it is sent.
                // console.log("http request config: " + angular.toJson(config));

                if (config.url.toLowerCase().indexOf('token/api') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                } else if (config.url.toLowerCase().indexOf('mec/api') >= 0) {
                    if (userProfileManager.isUserLoggedIn()) {
                        config.headers['eid'] = userProfileManager.getJWT();
                    }
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                } else if (config.url.toLowerCase().indexOf('mec/solr') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                } else if (config.url.toLowerCase().indexOf('mec/sf') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                } else if (config.url.toLowerCase().indexOf('eft-service') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                } else if (config.url.toLowerCase().indexOf('cpm-service') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                } else if (config.url.toLowerCase().indexOf('account-util/api') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                    if (userProfileManager.isUserLoggedIn()) {
                        config.headers['eid'] = userProfileManager.getJWT();
                    }
                } else if (config.url.toLowerCase().indexOf('/authorize/') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                } else if (config.url.toLowerCase().indexOf('/favorites/') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                } else if (config.url.toLowerCase().indexOf('customer/api') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                    if (userProfileManager.isUserLoggedIn()) {
                        config.headers['eid'] = userProfileManager.getJWT();
                    }
                } else if (config.url.toLowerCase().indexOf('shop-service/api') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                    if (userProfileManager.isUserLoggedIn()) {
                        config.headers['eid'] = userProfileManager.getJWT();
                    }
                } else if (config.url.toLowerCase().indexOf('invitation/api') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                    if (userProfileManager.isUserLoggedIn()) {
                        config.headers['eid'] = userProfileManager.getJWT();
                    }
                } else if (config.url.toLowerCase().indexOf('esb-util/api') >= 0) {
                    config.headers['client_id'] = mulesoftClientId;
                    config.headers['client_secret'] = mulesoftClientSecret;
                }


                if (config.url.indexOf('.html') < 0 && config.url.indexOf('.json') < 0 &&
                    config.url.indexOf('.css') < 0 && config.url.indexOf('.js') < 0) {
                    // hide global loader if showgloballoader value is false
                    if (config.headers['showgloballoader'] == false) {
                        $rootScope.showGlobalLoader = false;
                        if (document.getElementById('ns-accounts-global-loader')) {
                            document.getElementById('ns-accounts-global-loader').removeAttribute('opened');
                        }
                        numLoadings = 0;
                        urls = [];
                    } else {
                        if (config.headers['showgloballoader'] == true) {
                            // by default show global loader
                            numLoadings++;
                            urls.push(config.url);
                            $rootScope.showGlobalLoader = true;
                            // remove timeout after 15 seconds
                            $timeout(function() {
                                if ($rootScope.showGlobalLoader) {
                                    if (document.getElementById('ns-accounts-global-loader')) {
                                        document.getElementById('ns-accounts-global-loader').removeAttribute('opened');
                                    }
                                    $rootScope.showGlobalLoader = false;
                                }
                            }, 15000);
                            if (document.getElementById('ns-accounts-global-loader')) {
                                document.getElementById('ns-accounts-global-loader').setAttribute('opened', '');
                            }
                        }
                    }
                }

                delete config.headers.showgloballoader;
                // Return the config or wrap it in a promise if blank.
                return config || $q.when(config);
            },

            // On request failure
            requestError: function(rejection) {
                $timeout(function() {
                    if (urls.indexOf(rejection.config.url) > -1) {
                        if ((--numLoadings) <= 0) {
                            remove(urls, urls.indexOf(rejection.config.url));
                            $rootScope.showGlobalLoader = false;
                            if (document.getElementById('ns-accounts-global-loader')) {
                                document.getElementById('ns-accounts-global-loader').removeAttribute('opened');
                            }
                            numLoadings = 0;
                            urls = [];
                        }
                    }
                }, 100);

                // Return the promise rejection.
                return $q.reject(rejection);
            },

            // On response success
            response: function(response) {
                // Contains the data from the response.
                // console.log("http response config: " + angular.toJson(response));

                // Refreshing JWT token every we get from 'mec/api' service
                if (userProfileManager.isUserLoggedIn() && angular.isObject(response.config)) {
                    var url = response.config.url;
                    if (!angular.isUndefined(url) && url !=null) {
                        var urlLower = url.toLowerCase();
                        if ((urlLower.indexOf('customer/api')>= 0)
                            || (urlLower.indexOf('esb-util/api')>= 0)
                            || (urlLower.indexOf('account-util/api')>= 0)) {
                            var newJWT = response.headers('eid');
                            if (!angular.isUndefined(newJWT) && newJWT != null) {
                                cookieUtil.setCookie(userProfileManager.getJWTKey(), JSON.stringify(newJWT));
                            }
                        }
                    }
                }

                $timeout(function() {
                    if (urls.indexOf(response.config.url) > -1) {
                        if ((--numLoadings) <= 0) {
                            remove(urls, urls.indexOf(response.config.url));
                            $rootScope.showGlobalLoader = false;
                            if (document.getElementById('ns-accounts-global-loader')) {
                                document.getElementById('ns-accounts-global-loader').removeAttribute('opened');
                            }
                            numLoadings = 0;
                            urls = [];
                        }
                    }
                }, 100);
                // Return the response or promise.
                return response || $q.when(response);
            },

            // On response failture
            responseError: function(rejection) {
                // Contains the data about the error.
                // console.log("http response error: " + angular.toJson(rejection));

                // Redirecting to Login Page once we get 401 error from any service
                if (rejection.status == 401 && userProfileManager.isUserLoggedIn()) {
                    var userID = userProfileManager.getUserProfileMasterInfo().userId;
                    // window.location.protocol+'//'+window.location.host+ window.location.pathname;
                    var returnUrl = window.location.href;
                    // This cookie will expire in 20 min
                    cookieUtil.setCookie(userID+'returnUrlFor401Error', returnUrl, 20/1440);
                    // ###### CHANGED for refactoring
                    if (aConfig.site) {
                        userProfileManager.deleteUserProfileCookiesAndSignOut(aConfig.site['nvgsignoutpath'], false);
                    } else if (config.site) {
                        userProfileManager.deleteUserProfileCookiesAndSignOut(config.site['nvgsignoutpath'], false);
                    }
                    // ###### END
                    cookieUtil.setCookie('isSessionExpired', true);
                    cookieUtil.deleteCookie('totalItems');
                }
                $timeout(function() {
                    if (urls.indexOf(rejection.config.url) > -1) {
                        if ((--numLoadings) <= 0) {
                            remove(urls, urls.indexOf(rejection.config.url));
                            $rootScope.showGlobalLoader = false;
                            if (document.getElementById('ns-accounts-global-loader')) {
                                document.getElementById('ns-accounts-global-loader').removeAttribute('opened');
                            }
                            numLoadings = 0;
                            urls = [];
                        }
                    }
                }, 100);
                // Return the promise rejection.
                return $q.reject(rejection);
            }
        };
    }]);

    // Add the interceptor to the $httpProvider.
    $httpProvider.interceptors.push('CustomHttpInterceptor2');
};

intercepterConfig.$inject = ['$provide', '$httpProvider'];

CommonApp.module.config(intercepterConfig);





//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/config/http-intercepter.js
// module id = 229
// module chunks = 0